import { showNotification } from 'Store/notifications/actions';
import { commonOptions } from 'Store/notifications/utils';

import { NOTIFICATION_THEME_DARK } from 'Components/InAppNotification/constants';

export const RETRY_LAZY_REFRESHED = 'retry-lazy-refreshed';
const SERVICE_WORKER_SUPPORTED = typeof navigator !== 'undefined' && 'serviceWorker' in navigator;
export const SERVICE_WORKER_PATH = '/service-worker.js';
export const SERVICE_WORKER_ENABLED = SERVICE_WORKER_SUPPORTED && !__DEVELOPMENT__;
export const WEB_PUSH_SUPPORTED = typeof window !== 'undefined' && 'PushManager' in window;

const showUpdateNotification = (dispatch, handleReload) => {
  dispatch(
    showNotification({
      theme: NOTIFICATION_THEME_DARK,
      title: [{ id: 'modals.reload.title' }],
      body: [{ id: 'modals.reload.text' }],
      options: {
        onClick: handleReload,
      },
      icon: [commonOptions.icon],
    })
  );
};

let wb;

export const loadWorkboxWindow = async (callback) => {
  if (SERVICE_WORKER_ENABLED) {
    const { Workbox } = await import('workbox-window' /* webpackChunkName: "workbox-window" */);
    wb = new Workbox(SERVICE_WORKER_PATH);
    callback();
  }
};

export const postMessage = (type, payload) => {
  if (!SERVICE_WORKER_ENABLED) {
    return;
  }

  const { serviceWorker } = navigator;
  if (serviceWorker && wb) {
    serviceWorker.ready.then(() => {
      wb.messageSW({ type, payload });
    });
  }
};

export const registerServiceWorker = (dispatch) => {
  if (!SERVICE_WORKER_ENABLED || !wb) {
    return;
  }

  // https://developers.google.com/web/tools/workbox/guides/advanced-recipes
  // A service worker has installed but it's stuck in the waiting phase
  // we shouldn't be in this state as we already skipWaiting, but just to be safe
  wb.addEventListener('waiting', () => {
    const reloadFunction = () => {
      wb.addEventListener('controlling', () => {
        window.location.reload();
      });

      wb.messageSkipWaiting();
    };
    // Reset the lazy refreshed flag once a new version has released
    window.sessionStorage.setItem(RETRY_LAZY_REFRESHED, 'false');
    showUpdateNotification(dispatch, reloadFunction);
  });

  wb.register();
};
